import React, { useState } from "react";
import {
  Col,
  Row, Tabs
} from "antd";
import {
  BarsOutlined,
} from "@ant-design/icons";
import Report from "./Report";
import List from "./List";

const RiskAnalysis = () => {

  const [activeTabKey, setActiveTabKey] = useState("1")

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> RİSK ANALİZ RAPORU
          </p>
        </Col>
      </Row>

      <Tabs
        defaultActiveKey="1"
        onChange={(activeKey) => {
          setActiveTabKey(activeKey);
        }}
      >
        <Tabs.TabPane tab="Rapor Al" key="1">
          <div style={{ position: "relative" }}>
            <Report activeTabKey={activeTabKey} />
          </div>

        </Tabs.TabPane>
        <Tabs.TabPane tab="Geçmiş Raporlar" key="2">
          <List activeTabKey={activeTabKey} />
        </Tabs.TabPane>
      </Tabs>
    </>
  );
};


export default RiskAnalysis;
